/**
 * Created by supunm on 2/15/19.
 */

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name crewViolations.service:crewViolationsService
   *
   * @description
   *
   */
  angular
    .module('crewViolations')
    .service('crewViolationsService', crewViolationsService);

  function crewViolationsService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchCrewViolations = function (param, pageNumber, pageSize, showLoading,successFn, errorFn) {
      var searchParam = adaptSearchRequset(param, pageNumber, pageSize);
      if (showLoading) {
        RemoteService.searchCrewViolations(searchParam).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      }else{
        RemoteService.searchCrewViolationsWithoutLoading(searchParam).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      }

    };

    function adaptSearchRequset(param, pageNumber, pageSize) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        acType: (param.aircraftType != null) ? param.aircraftType.airCraftType : null,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        blankDaysOnly: param.blankDaysOnly,
        showCrewExpiries: param.showCrewExpiries,
        showWarning: param.showWarning,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null,
        ruleClassificationTypes: (param.ruleClassificationTypes != null && param.ruleClassificationTypes.length > 0)
          ? param.ruleClassificationTypes.map(function (item) {
            return item.ruleClassificationCode;
          })
          : null,
        pageNumber: pageNumber || 1,
        pageSize: pageSize || 100
      };

      return actualSearchParam;
    }

    vm.ignoreViolations = function (param, successFn, errorFn) {
      RemoteService.ignoreRegulationViolations(param).then(
        function (response) {
          successFn(response);
        },
        function(error) {
          errorFn(error.msg[0]);
        })
    }

    vm.restoreViolations = function (param, successFn, errorFn) {
      RemoteService.restoreRegulationViolations(param).then(
        function (response) {
          successFn(response);
        },
        function(error) {
          errorFn(error.msg[0]);
        })
    }

  }
}());
